import React, { FC } from 'react';
import { useFormik } from 'formik';
import * as _ from 'lodash';
import { observer } from 'mobx-react';
import { transport } from '@/core';
import { Language, languageService } from '@/core/language';
import { useCommonError } from '@/hooks/useCommonError';
import { buildGuestFormikConfig, UserForm } from '@/pages/profile';
import {
  Container,
  SkipButton,
} from '@/pages/profile/downloadGate/guestForm/GuestForm.sc';
import { IProfile } from '@/types';

const GuestFormPure: FC<{
  profile: IProfile;
  onSubmit;
  onSkip;
  onClose;
}> = ({ profile, onSubmit, onSkip, onClose }) => {
  const form = useFormik(buildGuestFormikConfig());
  const commonError = useCommonError();
  const handleSubmit = (errorHandler) => {
    transport
      .submitGuestForm(profile._id, form.values)
      .then(() => {
        onSubmit();
      })
      .catch((res) => {
        const error = _.get(res, 'response.data');
        return errorHandler.handle(error);
      })
      .catch(() => {
        commonError.show();
      });
  };

  return (
    <Container open>
      <UserForm
        data-test-automation-id="guest-form"
        form={form}
        onClose={onClose}
        onSubmit={handleSubmit}
        description={languageService.get(Language.GUEST_FORM_DESCRIPTION)}
        secondaryBtn={<SkipButton onClick={onSkip} />}
      />
    </Container>
  );
};

export const GuestForm = observer(GuestFormPure);
